import React from 'react';
import './ContactHero.css';

const ContactHero = () => {
    return (
        <section className="contact-hero">
            <div className="contact-hero-content">
                <h1>Contact Us – Prints Carts</h1>
                <p>
                    We’re here to assist you with product questions, order updates, and general shopping inquiries. 
                    At Prints Carts, we believe in clear communication and a smooth customer experience. 
                    If you need help choosing the right printing supplies or tracking an order, 
                    feel free to reach out at any time.
                </p>
            </div>
        </section>
    );
};

export default ContactHero;
